var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_security-on_btwg 2",
    clipPath: "url(#clip0_949_8886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.2113 79.984C36.9632 79.9799 35.7206 79.8203 34.5126 79.5089L34.2745 79.4435L34.0536 79.3336C26.0682 75.358 19.3314 70.1067 14.0303 63.7255C9.64199 58.4123 6.22071 52.3796 3.92024 45.8989C1.16923 38.1398 -0.154267 29.9527 0.0129134 21.7285C0.0162868 21.5559 0.0191417 21.4226 0.0191417 21.3308C0.0191417 17.3329 2.2539 13.8251 5.71244 12.3941C8.35943 11.2989 32.3929 1.49651 34.1294 0.788258C37.3996 -0.838879 40.8884 0.519223 41.4467 0.756718C42.699 1.26514 64.9164 10.2887 69.7176 12.5589C74.6657 14.8987 75.9859 19.1019 75.9859 21.2166C75.9859 30.7907 74.3161 39.7384 71.0228 47.8112C68.3632 54.3456 64.5936 60.3781 59.8784 65.6459C50.7809 75.8121 41.6809 79.4161 41.5931 79.4479C40.5055 79.8195 39.3613 80.0009 38.2113 79.984ZM36.0713 74.7203C36.8602 74.8959 38.6766 75.1594 39.8605 74.7305C41.3645 74.1859 48.981 70.2639 56.0984 62.3104C65.9322 51.3215 70.9218 37.5074 70.9291 21.252C70.9116 20.9226 70.676 18.5738 67.5435 17.0926C62.8355 14.8663 39.7423 5.48968 39.5096 5.39518L39.4458 5.36832C38.9618 5.16694 37.4217 4.74276 36.36 5.29521L36.1474 5.39362C35.89 5.49861 10.3782 15.9035 7.65739 17.0292C5.75408 17.8167 5.07593 19.7676 5.07593 21.3308C5.07593 21.445 5.07296 21.6112 5.06875 21.8259C4.8513 32.9485 7.44328 60.3177 36.0713 74.7203Z",
    fill: "#1C4E80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.187 3.0716C35.187 3.0716 9.44333 13.5709 6.68508 14.7121C3.92682 15.8533 2.5477 18.5923 2.5477 21.3312C2.5477 24.0702 0.479016 59.8097 35.187 77.0896C35.187 77.0896 38.3371 77.9551 40.727 77.0896C43.117 76.2241 73.4577 61.6165 73.4577 21.2171C73.4577 21.2171 73.4577 17.1087 68.6308 14.8262C63.8038 12.5438 40.4664 3.0716 40.4664 3.0716C40.4664 3.0716 37.6004 1.81626 35.187 3.0716Z",
    fill: "#349DD8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.1,
    d: "M37.9451 11.2871V67.297C37.9451 67.297 11.9716 54.8819 12.2015 22.2429L37.9451 11.2871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.7843 51.9993L21.3333 41.3524L27.411 37.6071L32.3595 42.6482L49.0765 28.666L54.6666 32.8625L31.7843 51.9993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_8886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityOn);
export default __webpack_public_path__ + "static/media/security_on.cb04470dec3e3e2a240ef07bd14101aa.svg";
export { ForwardRef as ReactComponent };